import { render, staticRenderFns } from "./CollectEmptyLink.vue?vue&type=template&id=4bfdce8f&scoped=true"
import script from "./CollectEmptyLink.vue?vue&type=script&lang=js"
export * from "./CollectEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfdce8f",
  null
  
)

export default component.exports